export default {
  search: ['请输入搜索的权限名称', 'Please enter role name'],
  name: ['权限名称', 'Role Name'],
  key: ['权限组代码', 'Role Code'],
  permission: ['特殊授权', 'Permission'],
  note: ['备注', 'Note']
};
